module.exports = "img/flags/EE.c17ece9.png";